

















import {computed, defineComponent, onMounted, ref} from "@vue/composition-api";
import {useGetters, useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: 'SearchBar',
  setup() {
    const store = useStore();
    const { labels } = useGetters(['labels']);
    const searchInput = ref<HTMLInputElement | null>(null);

    const searchQuery = computed({
      get() {
        return store.state.searchQuery;
      },
      set(value: string): void {
        store.commit('setSearchQuery', value);
      },
    });

    onMounted(() => {
      if (searchInput.value) {
        searchInput.value.focus();
      }
    });

    return {
      labels,
      searchQuery,
      searchInput
    };
  }
});
